__turbopack_context__.v({
  "container": "AddToCartButtonPersistent-module-scss-module__bEx-lW__container",
  "open": "AddToCartButtonPersistent-module-scss-module__bEx-lW__open",
});
